import React from 'react';
import { Icon } from './Icon.js';
export const IconBox2 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M12 3V9", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M3 9H21", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M21 21L21 9L19 3L5 3L3 9L3 21L21 21Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M17 17L15 17", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", strokeLinejoin: "round", "data-color": "color-2", fill: "none" })));
};
//# sourceMappingURL=IconBox2.js.map